import React from 'react';
import { Image, Path, StyleSheet, Svg, Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import CardItem from './CardItem';
import Header from './Header';
import SelectionsLabel from './SelectionsLabel';
const styles = StyleSheet.create({
    image: {
        width: '420px',
        height: '200px',
        marginTop: '8px',
        objectFit: 'contain',
    },
    imageContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    container: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: '16px',
    },
    info: {
        flexDirection: 'row',
        marginBottom: '50px',
        alignItems: 'flex-end',
    },
    sellingPrice: {
        fontSize: '12px',
        letterSpacing: '0.5px',
    },
    price: {
        fontSize: '18px',
        fontWeight: 'bold',
    },
    priceLabel: {
        fontSize: '12px',
        letterSpacing: '0.5px',
        marginBottom: '10px',
    },
});
const FirstPage = ({ firstPageData, selectedItemsList, isVariant, markdownModelName, }) => {
    const { t } = useTranslation();
    const { image, badgePaths, sellingPrice, priceLabel, paymentFrequencyLabel, price, termByMonths } = firstPageData;
    return (React.createElement(View, null,
        React.createElement(Header, null),
        React.createElement(View, { style: styles.imageContainer }, image && React.createElement(Image, { src: image, style: styles.image })),
        React.createElement(View, { style: styles.container },
            React.createElement(View, { style: { flexDirection: 'column' } },
                (badgePaths === null || badgePaths === void 0 ? void 0 : badgePaths.length) && (React.createElement(Svg, { width: "133px", height: "11px", viewBox: "0 0 133 11", preserveAspectRatio: "preserve" }, badgePaths === null || badgePaths === void 0 ? void 0 : badgePaths.filter((d) => d !== undefined).map((d, index) => (React.createElement(Path, { key: index, d: d, stroke: "black", fill: "black" }))))),
                React.createElement(View, { style: { display: 'flex', flexDirection: 'row', marginTop: '8px' } }, markdownModelName)),
            React.createElement(View, { style: { flexDirection: 'column' } },
                React.createElement(Text, { style: styles.sellingPrice }, t('Shared.Common.sellingPriceLabel')),
                React.createElement(Text, { style: styles.price }, sellingPrice))),
        React.createElement(View, { style: styles.info },
            React.createElement(View, { style: { width: '50%', borderRight: '1px solid #EAEAEA' } },
                React.createElement(Text, { style: styles.priceLabel }, priceLabel),
                React.createElement(View, { style: { flexDirection: 'row', alignItems: 'flex-end' } },
                    React.createElement(Text, { style: { fontSize: '14px', fontWeight: 'bold' } }, price),
                    React.createElement(Text, { style: { marginLeft: '8px', fontSize: '14px' } }, paymentFrequencyLabel))),
            React.createElement(View, { style: { marginLeft: '16px' } },
                React.createElement(Text, { style: styles.priceLabel }, t('Shared.Common.termByMonthLabel')),
                React.createElement(View, null,
                    React.createElement(Text, { style: { fontSize: '14px', fontWeight: 'bold' } }, termByMonths)))),
        React.createElement(SelectionsLabel, null), selectedItemsList === null || selectedItemsList === void 0 ? void 0 :
        selectedItemsList.map(item => (React.createElement(CardItem, { item: item, key: item.id, isVariant: isVariant })))));
};
export default FirstPage;
